var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s("タグを消去") + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: { click: _vm.close },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0 tag_delete_body" },
                  [
                    _c("div", { staticClass: "tag_delete_text" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            "「" + _vm.tagName + "」のタグを消去します。"
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "v-row",
                      {
                        staticClass: "ma-0 pa-0 mt-12 pb-4",
                        attrs: { justify: "center" },
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "tag_delete_cancel_btn",
                            attrs: {
                              width: "8rem",
                              height: "2.5rem",
                              depressed: "",
                            },
                            on: { click: _vm.close },
                          },
                          [_vm._v(_vm._s("キャンセル"))]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "tag_delete_confirm_btn ml-3",
                            attrs: {
                              width: "8rem",
                              height: "2.5rem",
                              depressed: "",
                              loading: _vm.loading,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("confirm")
                              },
                            },
                          },
                          [_vm._v(_vm._s("消去"))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }